exports.linkParser = (uri) => {
  // Step 1: Trim leading and trailing whitespace
  let fixedUri = uri.trim()

  // Step 2: Replace double slashes with a single slash, remove duplicate 'en' language code, and remove any spaces within the URI
  fixedUri = fixedUri.replace(/\/{2,}|\/en\/en\/|\s+/g, (match) => {
    if (match === '//') return '/'
    if (match === '/en/en/') return '/en/'
    return ''
  })

  // Step 3: Ensure no duplicate 'en' language code at the beginning
  fixedUri = fixedUri.replace(/^\/en\/en\//, '/en/')

  return fixedUri
}
